import { MEDIA_STATE_QUICKLOOK } from '@frameio/graphql-client/client-schema/media-state/MediaState.state';
import type {
  MediaStateIdEnum,
  TimeDisplayFormat,
} from '@frameio/graphql-client/generated';
import type { PageType } from '../../../routing/types';

type ViewerTypes = 'ViewerPanel' | 'ViewerPage' | 'ReelPlayer' | 'Quicklook';
type SourceTypes = 'Collection' | 'Project' | 'ShareViewer' | 'ShareBuilder';

export const getDerivedPlayerTypeAppDir = (
  route: PageType,
  mediaStateId: MediaStateIdEnum
): ViewerTypes | undefined => {
  if (mediaStateId === MEDIA_STATE_QUICKLOOK) return 'Quicklook';

  switch (route) {
    case 'folder':
    case 'collection':
      return 'ViewerPanel';
      break;
    case 'shareBuilder':
      return 'ReelPlayer';
      break;
    case 'shareReviewReel':
      return 'ReelPlayer';
      break;
    case 'collectionViewer':
    case 'shareBuilderViewer':
    case 'folderViewer':
    case 'shareReviewFinder':
      return 'ViewerPage';
      break;
    default:
      return undefined;
  }
};

export const getDerivedSourceAppDir = (
  currentPageType: PageType
): SourceTypes | undefined => {
  switch (currentPageType) {
    case 'folder':
    case 'folderViewer':
      return 'Project';
      break;
    case 'collectionViewer':
    case 'collection':
      return 'Collection';
      break;
    case 'shareBuilderViewer':
    case 'shareBuilder':
      return 'ShareBuilder';
      break;
    case 'shareReviewFinder':
    case 'shareReviewReel':
      return 'ShareViewer';
      break;
    default:
      return undefined;
  }
};

export const FileOrigin = {
  generated: 'Automated',
  upload: 'Uploaded',
  asset: 'Extracted',
  GENERATED: 'Automated',
  UPLOAD: 'Uploaded',
  ASSET: 'Extracted',
};

export const TimeFormat: Record<
  TimeDisplayFormat,
  'Frames' | 'Standard' | 'Timecode'
> = {
  FRAME: 'Frames',
  STANDARD: 'Standard',
  TIMECODE: 'Timecode',
};

export type FileOriginKey = keyof typeof FileOrigin;
export type FileOriginType = (typeof FileOrigin)[keyof typeof FileOrigin];

export type TrackingSourceType =
  | 'AccountSettings'
  | 'AssetContextMenu'
  | 'BottomActionBar'
  | 'BreadcrumbsFolderMenu'
  | 'FinderMenuBar'
  | 'FolderFacepile'
  | 'Home'
  | 'InviteModal'
  | 'ProjectBreadcrumbs'
  | 'ProjectFacepile'
  | 'ProjectHeaderMenu'
  | 'ProjectInviteModalProjectPage'
  | 'ProjectInviteModalProjectPageAccountSettings'
  | 'ProjectNavFolderMenu'
  | 'ProjectNavProjectMenu'
  | 'ProjectPageAccountSettings'
  | 'ProjectPanelAccountSettings'
  | 'ProjectSettingsFromProject'
  | 'ProjectSettingsFromWorkspace'
  | 'UserPageAccountSettings'
  | 'UserPageAddSelectedAccountSettings'
  | 'UserPageNewUserButtonAccountSettings'
  | 'UserPanelAccountSettings'
  | 'Workspace'
  | 'WorkspaceFacepile'
  | 'WorkspaceInviteModalHomePage'
  | 'WorkspaceInviteModalWorkspacePageAccountSettings'
  | 'WorkspacePageAccountSettings'
  | 'WorkspacePanelAccountSettings'
  | 'WorkspaceSettingsFromWorkspace'
  | '';
